var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"loading":_vm.loading,"objectName":"venues","data":_vm.venues,"tableHeader":_vm.headers,"fields":_vm.venuesFields,"url":"/venue","refresh":_vm.getVenues,"allowCreation":true}})}
var staticRenderFns = []

export { render, staticRenderFns }